import { render, staticRenderFns } from "./UserFields.vue?vue&type=template&id=85d60e2c&"
import script from "./UserFields.vue?vue&type=script&lang=js&"
export * from "./UserFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports